import { useState } from 'react';
import { ButtonDel } from '@UI/Button';
import { CloseIcon, DivideIcon, SquareRootIcon } from '@/utils/icons';
import commonStyle from '../common.module.css';
import s from './index.module.css';
import classNames from 'classnames';
import { BlockMath } from 'react-katex';
import { DynamicInput } from '@UI/New/DynamicInput';
import { MULTIPLICATION, FRACTION, SQUAREROOT, DIVIDE, SUBTRACTION, ADDITION, NTHROOT, MIXEDFRACTION } from '../../constants';

export const Content = ({value, edit, prohibitEditing}) => {

    const editData = ({id, type, passedValue}) => {
        if(prohibitEditing) return false;

        edit( 
            value.map((el) => {
                if(el.id == id) {
                    return {
                        ...el,
                        [type]: passedValue
                    }
                }
                return el;
            })
        )
    }

    const deleteItem = (id) => {
        edit( 
            value.filter((el) => el.id !== id)
        )
    }

    return (
        <div className={s.contentWrapper}>
            {
                value.map((el) => {
                    if(el.type === FRACTION){
                        return (
                            <div key={el.id} className={classNames(s.fraction, s.item)}>
                                {
                                    !prohibitEditing && <ButtonDel type="button" className={s.delete} onClick={() => deleteItem(el.id)} />
                                }
                                <DynamicInput 
                                    onInput={(e) => editData({id: el.id, type: 'numerator', passedValue: e.target.value})}
                                    value={el.numerator}
                                    className={classNames(s.input, commonStyle.input)}
                                />
                                <div className={s.fractionLine}></div>
                                <DynamicInput 
                                    onInput={(e) => editData({id: el.id, type: 'denominator', passedValue: e.target.value})}
                                    value={el.denominator}
                                    className={classNames(s.input, commonStyle.input)}
                                />
                            </div>
                        )
                    }
                    if(el.type === MIXEDFRACTION){
                        return (
                            <div className={s.mixedFraction}>
                                <DynamicInput 
                                    onInput={(e) => editData({id: el.id, type: 'wholePart', passedValue: e.target.value})}
                                    value={el.wholePart}
                                    className={classNames(s.input, commonStyle.input)}
                                />
                                <div key={el.id} className={classNames(s.fraction, s.item)}>
                                    {
                                        !prohibitEditing && <ButtonDel type="button" className={s.delete} onClick={() => deleteItem(el.id)} />
                                    }
                                    <DynamicInput 
                                        onInput={(e) => editData({id: el.id, type: 'numerator', passedValue: e.target.value})}
                                        value={el.numerator}
                                        className={classNames(s.input, commonStyle.input)}
                                    />
                                    <div className={s.fractionLine}></div>
                                    <DynamicInput 
                                        onInput={(e) => editData({id: el.id, type: 'denominator', passedValue: e.target.value})}
                                        value={el.denominator}
                                        className={classNames(s.input, commonStyle.input)}
                                    />
                                </div>
                            </div>
                        )
                    }
                    if(el.type === SQUAREROOT){
                        return (
                            <div key={el.id} className={classNames(s.squareRoot, s.item)}>
                                {
                                    !prohibitEditing && <ButtonDel type="button" className={s.delete} onClick={() => deleteItem(el.id)} />
                                }
                               
                                <div className={s.squareRootIconAndInput}>
                                    <SquareRootIcon />
                                    <DynamicInput 
                                        onInput={(e) => editData({id: el.id, type: 'value', passedValue: e.target.value})}
                                        value={el.value}
                                        className={classNames(s.input, commonStyle.input)}
                                    />
                                </div>
                            </div>
                        )
                    }
                    if(el.type === NTHROOT){
                        return (
                            <div key={el.id} className={classNames(s.squareRoot, s.item)}>
                                {
                                    !prohibitEditing && <ButtonDel type="button" className={s.delete} onClick={() => deleteItem(el.id)} />
                                }
                               
                                <div className={s.squareRootIconAndInput}>
                                    <SquareRootIcon />
                                    <input
                                         style={{fontSize: String(el.degree)?.length > 1 ? '9px' : undefined}}
                                         onInput={(e) => editData({id: el.id, type: 'degree', passedValue: e.target.value})}
                                         value={el.degree}
                                         className={classNames(s.inputDegree)}
                                    />
                                    <DynamicInput 
                                        onInput={(e) => editData({id: el.id, type: 'value', passedValue: e.target.value})}
                                        value={el.value}
                                        className={classNames(s.input, commonStyle.input)}
                                    />
                                </div>
                            </div>
                        )
                    }
                    if(el.type === MULTIPLICATION){
                        return (
                            <div key={el.id} className={classNames(s.multiplication, s.item)}>
                                {
                                    !prohibitEditing && <ButtonDel type="button" className={s.delete} onClick={() => deleteItem(el.id)} />
                                }
                                
                                ×
                            </div>
                        )
                    }
                    if(el.type === DIVIDE){
                        return (
                            <div key={el.id} className={classNames(s.divide, s.item)}>
                                {
                                    !prohibitEditing && <ButtonDel type="button" className={s.delete} onClick={() => deleteItem(el.id)} />
                                }
                                
                                ÷
                            </div>
                        )
                    }
                    if(el.type === ADDITION){
                        return (
                            <div key={el.id} className={classNames(s.addition, s.item)}>
                                {
                                    !prohibitEditing && <ButtonDel type="button" className={s.delete} onClick={() => deleteItem(el.id)} />
                                }
                                
                                +
                            </div>
                        )
                    }
                    if(el.type === SUBTRACTION){
                        return (
                            <div key={el.id} className={classNames(s.subtraction, s.item)}>
                                {
                                    !prohibitEditing && <ButtonDel type="button" className={s.delete} onClick={() => deleteItem(el.id)} />
                                }
                                
                                -
                            </div>
                        )
                    }
                    return <></>
                    
                })
            }
        </div>
    );
};
